module.exports = __webpack_public_path__ + "img/voice-thumb2.5bc9bf4.jpg";